import React from 'react';
import { useTheme } from './ThemeContext';

const OnboardingStep = ({ 
  step, 
  totalSteps, 
  onNext, 
  onBack, 
  onSkip, 
  children,
  canSkip = true,
  nextLabel = "Next",
  showBack = true
}) => {
  const { isDarkMode } = useTheme();

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-[100] p-4">
      <div 
        className={`${
          isDarkMode 
            ? 'bg-gradient-to-br from-indigo-900/95 to-purple-900/95 border-white/20' 
            : 'bg-gradient-to-br from-blue-50 to-purple-50 border-gray-200'
        } rounded-2xl p-6 md:p-8 max-w-2xl w-full border-2 shadow-2xl relative`}
      >
        {/* Skip button */}
        {canSkip && (
          <button
            onClick={onSkip}
            className={`absolute top-4 right-4 ${
              isDarkMode ? 'text-white/60 hover:text-white' : 'text-gray-500 hover:text-gray-800'
            } text-sm font-medium transition-colors`}
          >
            Skip Tutorial
          </button>
        )}

        {/* Content */}
        <div className="mb-8">
          {children}
        </div>

        {/* Progress dots */}
        <div className="flex justify-center gap-2 mb-6">
          {Array.from({ length: totalSteps }).map((_, index) => (
            <div
              key={index}
              className={`h-2 rounded-full transition-all ${
                index === step - 1
                  ? 'w-8 bg-gradient-to-r from-purple-500 to-pink-500'
                  : index < step - 1
                  ? 'w-2 bg-purple-400/50'
                  : `w-2 ${isDarkMode ? 'bg-white/20' : 'bg-gray-300'}`
              }`}
            />
          ))}
        </div>

        {/* Navigation buttons */}
        <div className="flex justify-between gap-4">
          {showBack && step > 1 ? (
            <button
              onClick={onBack}
              className={`px-6 py-3 rounded-lg font-semibold transition-all ${
                isDarkMode
                  ? 'bg-white/10 hover:bg-white/20 text-white border border-white/20'
                  : 'bg-gray-200 hover:bg-gray-300 text-gray-800 border border-gray-300'
              }`}
            >
              Back
            </button>
          ) : (
            <div></div>
          )}

          <button
            onClick={onNext}
            className="px-8 py-3 rounded-lg font-bold text-white bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 transition-all shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            {nextLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingStep;
